// extracted by mini-css-extract-plugin
module.exports = {"newsfeedCard":"ug"};